/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordChangeTokenRequestBody
 */
export interface PasswordChangeTokenRequestBody {
    /**
     * 
     * @type {string}
     * @memberof PasswordChangeTokenRequestBody
     */
    email: string;
}

export function PasswordChangeTokenRequestBodyFromJSON(json: any): PasswordChangeTokenRequestBody {
    return PasswordChangeTokenRequestBodyFromJSONTyped(json, false);
}

export function PasswordChangeTokenRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordChangeTokenRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function PasswordChangeTokenRequestBodyToJSON(value?: PasswordChangeTokenRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

